import React, { useEffect, useState } from 'react';
import Moment from 'react-moment';

const CoinTable = ({ className }) => {
    const [coins, setCoins] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getCoins = async () => {
        try {
            const response = await fetch('https://api.coinpaprika.com/v1/tickers?limit=300');
            const json = await response.json();
            setCoins(json);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getCoins();
    }, []);

    return (
        <div className={`card card-custom ${className}`}>
            {/* Head */}
            <div className="card-header border-0 py-5">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label font-weight-bolder text-dark">Coins</span>
                    <span className="text-muted mt-3 font-weight-bold font-size-sm">Coin list from coinpaprika.com</span>
                </h3>
                <div className="card-toolbar">
                    <a href="#" className="btn btn-info font-weight-bolder font-size-sm mr-3">
                        Button1
                    </a>
                    <a href="#" className="btn btn-danger font-weight-bolder font-size-sm">
                        Button2
                    </a>
                </div>
            </div>
            {/* Body */}
            <div className="card-body pt-0 pb-3">
                <div className="tab-content">
                    <div className="table-responsive">
                        <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
                            <thead>
                                <tr className="text-left text-uppercase">
                                    <th className="pl-7" style={{ minWidth: '250px' }}>
                                        <span className="text-dark-75">Coin Name</span>
                                    </th>
                                    <th style={{ minWidth: '100px' }}>Price</th>
                                    <th style={{ minWidth: '80px' }}>Highest Price</th>
                                    <th style={{ minWidth: '100px' }}>Market Cap</th>
                                    <th style={{ minWidth: '100px' }}>Supply</th>
                                    <th style={{ minWidth: '130px' }}>Updated Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading && (
                                    <tr>
                                        <td className="text-center py-8" colSpan="6">
                                            <span className="mr-2 text-muted">Loading...</span>
                                            <span className="spinner spinner-success"></span>
                                        </td>
                                    </tr>
                                )}

                                {coins.map((coin) => (
                                    <tr key={coin.id}>
                                        <td className="pl-0 py-8">
                                            <div className="d-flex align-items-center">
                                                <div className="symbol symbol-50 symbol-light mr-4">
                                                    <span className="symbol-label">
                                                        <span className="text-center">
                                                            <img
                                                                src={`https://static.coinpaprika.com/coin/${coin.id}/logo.png`}
                                                                className="w-75 p-1"
                                                            />
                                                        </span>
                                                    </span>
                                                </div>
                                                <div>
                                                    <a
                                                        href="#"
                                                        className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                                                    >
                                                        {coin.name}
                                                    </a>
                                                    <span className="text-muted font-weight-bold d-block">{coin.symbol}</span>
                                                </div>
                                            </div>
                                        </td>

                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                ${coin.quotes.USD.price.toLocaleString()}
                                            </span>
                                            <span className="text-muted font-weight-bold">{coin.quotes.USD.percent_change_24h}%</span>
                                        </td>

                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                ${coin.quotes.USD.ath_price.toLocaleString()}
                                            </span>
                                            <span className="text-muted font-weight-bold">{coin.quotes.USD.percent_from_price_ath}%</span>
                                        </td>

                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                ${coin.quotes.USD.market_cap.toLocaleString()}
                                            </span>
                                            <span className="text-muted font-weight-bold">Rank #{coin.rank}</span>
                                        </td>

                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                {coin.total_supply.toLocaleString()}
                                            </span>
                                            <span className="text-muted font-weight-bold">{coin.max_supply.toLocaleString()}</span>
                                        </td>

                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                <Moment date={coin.last_updated} format="YYYY-MM-DD HH:mm:ss (Z)" />
                                            </span>
                                            <span className="text-muted font-weight-bold font-size-sm">
                                                <Moment date={coin.first_data_at} format="YYYY-MM-DD HH:mm:ss (Z)" />
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoinTable;
